import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation UpdateCustomerSubscription(
    $customerId: ID!
    $plan: String!
    $wordsTier: String
    $billingCycle: String
    $promotionCode: String
  ) {
    updateCustomerSubscription(
      customerId: $customerId
      plan: $plan
      wordsTier: $wordsTier
      billingCycle: $billingCycle
      promotionCode: $promotionCode
    ) {
      status
      latestInvoice {
        paymentIntentStatus
        paymentIntentClientSecret
      }
    }
  }
`;

export const updateCustomerSubscription = ({
  customerId,
  plan,
  tier,
  billingCycle,
  promotionCode,
}) =>
  executeGqlMutation({
    mutation: MUTATION,
    variables: {
      customerId,
      plan,
      wordsTier: tier,
      billingCycle,
      promotionCode,
    },
  }).then(({ data }) => getSingleProp(data));
